const googleAds = {
  googleAds: 'Informe de anuncios',
  showing: 'Mostrando',
  googleAdsOf: 'registros',
  noGoogleAdsFound: 'No se encontraron registros',
  addNewRecords: 'Añadir nuevos registros',
  successfullyAdded: 'Todos los registros añadidos correctamente',
  delete: 'Eliminar',
};
export default googleAds;
